import React, { useState } from 'react';
import { Button, ButtonGroup } from '@material-ui/core';

import PrescriptionFamilyGroupList from './PrescriptionFamilyGroupList';
import HeaderImage from '../../../assets/img/misRecetas.svg';
import { PrescriptionType } from '../../../models/enums';

const Prescription = () => {
   const [prescriptionType, setPrescriptionType] = useState(
      PrescriptionType.NEW,
   );

   return (
      <div className="prescription">
         <div className="header">
            <div className="image-title">
               <img src={HeaderImage} alt="Mis Prescripciones" />
               <h2>Mis Prescripciones</h2>
            </div>
         </div>
         <div className="container">
            <PrescriptionFamilyGroupList filterStatus={prescriptionType} />
         </div>
      </div>
   );
};

export default Prescription;
